var msg = new Array();
msg['ERR_CARRIERMISSING']='Вы должны выбрать тип отгрузки';
msg['ERR_CARRIER_COST_MISSING']='Никакие применимые тарифы по странам, курьеру и весу заказа.';
msg['ERR_CLIENTMANDATORYFIELDS']='Отмеченные поля, обязательные';
msg['ERR_FILLEMAILFIELD']='Заполните поле электронной почты';
msg['ERR_INVALIDMAIL']='Недействительный адрес электронной почты';
msg['ERR_LOGININVALID']='Недействительный адрес электронной почты и / или пароль';
msg['ERR_LOGINREQUIRED']='Вы должны войти в систему';
msg['ERR_MISSINGFIELDS']='Заполните правильно все обязательные поля';
msg['ERR_NOSIZESELECTED']='Сначала вы должны выбрать размер';
msg['ERR_PRIVACY']='Вы должны принять условия';
msg['ERR_USEREXISTS']='Пользователь уже существует.';
msg['LABEL_ALREADYREGISTEREDUSERES']='Пользователи уже зарегистрированы';
msg['LABEL_ARTICLES']='артикулы';
msg['LABEL_INVITES_ALREADY_SENT']='Пользователи уже приглашены';
msg['LABEL_NOTAPPLICABLE']='Не применимо';
msg['LABEL_NOTSENTINVITES']='Приглашения не отправлены';
msg['LABEL_SELECTALL']='Отметить все';
msg['LABEL_SENTINVITES']='Приглашения отправлены';
msg['LABEL_SUBMIT']='Отправить';
msg['LABEL_WARNING']='Внимание!';
msg['MSG_ADDEDTOCART']='Товар добавлен в корзину';
msg['MSG_ADDEDTOWISHLIST']='Товар добавлен к список пожеланий';
msg['MSG_APPLIEDVATCHANGED']='После этого обновления платежной информации НДС, внесенный в ваш заказ, изменился.';
msg['MSG_COUPON_ERROR']='Неверный код введенного купона или он был введен ранее.';
msg['MSG_COUPON_VALID']='Код купона успешно подтвержден.';
msg['MSG_DEFERRED_DISPATCH_COMPUTATION']='Только одно бронирование заказа будет включено, а стоимость доставки будет отправлена по электронной почте';
msg['MSG_EXTRAUELIMIT']='Минимальная сумма вашего заказа не может быть меньше 2000,00 евро';
msg['MSG_GENERIC_ERROR']='Произошла ошибка.';
msg['MSG_INSUFFICIENT_STOCK']='На данный момент количество товара недостаточно';
msg['MSG_MAILSENT']='Отправленные е-мейлы';
msg['MSG_MESSAGE_PRODUCTSHARE']='Сообщение';
msg['MSG_MESSAGE_SENT']='Сообщение отправлено!';
msg['MSG_MIXED_CART']='Товары в корзине не могут быть приобретены вместе с выбранным товаром, потому что они находятся на разных складах.';
msg['MSG_MIXED_INTANGIBLE']='Товары в корзине не могут быть приобретены вместе с выбранным продуктом.';
msg['MSG_PAYMENT_PENDING'] = 'Оплата в ожидании подтверждения';
msg['MSG_PROFILECONSENT_SAVED'] = 'Ваши контактные предпочтения были обновлены';
msg['MSG_RECOVEREMAILSENT']='Проверьте свою электронную почту и нажмите на ссылку, чтобы подтвердить изменение. ';
msg['MSG_RECOVEREMAILSENT_ERROR']='Attenzione: Вы не зарегистрированы на этом электронном адресе, или вы уже сбросили новый пароль.';
msg['MSG_RETURN_REQUEST_SUCCESS'] = 'Обратный запрос создан c успехом';
msg['MSG_RULE_REJECT']='Product cannot be added to cart because of rule :rule';
msg['MSG_SAVE_SUCCESS'] = 'Сохранено успешно';
msg['MSG_SELECT_PROVINCE']='Choose a province';
msg['MSG_SENDER_PRODUCTSHARE']='Ваше имя';
msg['MSG_SUBJECT_PRODUCTSHARE']=' он поделился с тобой';
msg['MSG_SUBSCRIBED'] = 'Зарегистрировано успешно';
msg['MSG_SUBSCRIPTION_FAILURE']='Make sure you do not have any other active subscription.';
msg['MSG_SUBSCRIPTION_NO_RENEWABLE'] = 'Прошло слишком много дней, поэтому подписка больше не возобновляется';
msg['MSG_WAIT']='Подождите ...';
msg['msg.form.invalidtype'] = 'Произошла ошибка. Пожалуйста, свяжитесь с администрацией, сообщив следующее: "Неверный или отсутствующий тип контакта."';
msg['msg.form.invalidemail'] = 'Неверный или отсутствующий адрес электронной почты';
msg['msg.form.invalidrecipients'] = 'Произошла ошибка. Свяжитесь с администрацией, сообщив следующее: "Получатель контакта недействителен или отсутствует."';

var portal_livestock_available='ИМЕЕТСЯ В НАЛИЧИИ';
var portal_livestock_soldout='НЕТ В НАЛИЧИИ';

var activity_online_shop = 'интернет-магазин';
var activity_shop = 'магазин';
var activity_private_sales = 'частные продажи';
var activity_outlet = 'магазин по продаже';
var activity_online_outlet = 'магазин по продаже онлайн';
var activity_store_chain = 'сеть магазинов';
var activity_purchasing_group = 'группа покупок';
var activity_broker = 'брокер агент';
var activity_ebay_amazon = 'магазин ebay/amazon';
var activity_other = 'другое';

var general="Общий";
var general_personaldata='Личные данные';
var general_olduser='Зарегистрированный пользователь';
var general_newuser='Новый пользователь';
var general_username='Имя пользователя';
var general_password="Пароль";
var general_contacts="Контакты";
var general_phone="Телефон";
var general_skype="Skype";
var general_website="Веб-сайт";
var general_fax="Факс";
var general_firstname='Имя';
var general_lastname='фамилия';
var general_company='Предприятие';
var general_birth='Дата рождения';
var general_code='Код';
var general_model='Модель';
var general_quantity='Количество';
var general_availability='Доступность';
var general_price='Цена';
var general_warning='Обратите внимание';
var general_dispatchto='Получатель';
var general_careof='C/O';
var general_vat='налоговый код,  НДС';
var general_address='Адрес';
var general_addresstype='Улица';
var general_addressnumber='Городской';
var general_city='Город';
var general_prov='Провинция';
var general_zip='почтовый индекс';
var general_mobile='Мобильный телефон';
var general_notes='Отметки';
var general_orders='Заказы';
var general_fgfdiscounts='Друзья и скидки';
var general_myprofile='Мой профиль';
var general_pieces='штуки';
var general_size_table='Таблица размеров';
var general_details='Подробнее';
var general_invoice='Счет-проформа';
var general_creditnote='Кредыт-нота';
var general_cart= 'Корзина';
var general_country='Страна';
var general_carrier='Курьер';
var general_dispatch_address='Адрес доставки';
var general_invoice_address='Адрес выставления счетов';
var general_receive_newsletter='Получать рассылку';
var general_copydispatchfrombilldata='Копировать из платежной информации';
var general_instructions="Инструкции";
var general_add='Добавить';
var general_status="Состояние";
var general_toomanyfilters="Вы достигли максимального количества разрешенных фильтров.";

var help_addresstype='Улнца, Площадь, Проспект, ...';
var help_address='Введите название улицы';
var help_dispatchmobile='Введите номер телефона,  по которому можно связаться для доставки.';
var help_ordercfpiva='Если оставить это поле пустым, будет автоматически приложен налог НДС к общей суме заказа.';
var help_cf='Введите номер своего налогового кода';

var buttons_save='Сохранить';
var buttons_changepw='Изменить пароль';
var buttons_close='Закрой';
var buttons_continue='Продолжайе';
var buttons_confirm='Подтвердить';
var buttons_cancel='Отменить';
var buttons_invite='Пригласить';
var buttons_continueshopping='Продолжать покупку';
var buttons_gocheckout='Перейти в корзину';

var messages_product_soldout='Продукт распроданный ';
var messages_noselection='Выбор пустой';
var messages_invaliddata='Заполните правильно все поля';
var messages_recoverpassword='Восстановить пароль';
var messages_recoverpassword_info='Введите адрес электронной почты, который вы зарегистрировали. Электронное письмо будет отправлено вам с инструкциями по установке нового пароля.';
var messages_invitefriends='Пригласите друзей';
var messages_confirmpassword='Подтвердить пароль';
var messages_sendingmail='Электронная почта в фазе отправки ...';
var messages_mailsent='Электронные письма отправлены с успехом.';
var messages_password='Пароль';
var messages_confirmpassword='Подтвердить пароль';
var messages_requiredfield='Обязательное поле';

var subscribe_personaldata='Обработка данных';
var subscribe_privacyintro='Чтобы продолжить регистрацию, необходимо ознакомиться с политикой конфиденциальности и разрешить обработку персональных данных';
var subscribe_privacydisclaimer='Вы должны принять  условие конфиденциальности для завершения регистрации';
var subscribe_privacy1='Нижеподписавшийся подтверждает, что он прочитал и принял  условие конфиденциальности';
var subscribe_privacy2='Нижеподписавшийся уполномочивает передавать свои данные третьим лицам для коммерческих действий (необязательно)';

var order_status='Состояние';
var order_date='Дата';
var order_dispatchdate='Отправен';

var returnedgoods_requests="Вопросы возврата";
var returnedgoods_motivations="Причина возврата";
var returnedgoods_requestcode="Код возврата";
var returnedgoods_requestdate="Дата запроса на возврат";
var returnedgoods_motivations_1="Товар мне не удовлетворяет";
var returnedgoods_motivations_2="Товар слишком большой / маленький";
var returnedgoods_motivations_3="Товар поврежден";
var returnedgoods_motivations_4="Полученный товар не соответствует запрашиваемому продукту";
var returnedgoods_motivations_5="Товар отсутствует в упаковке";
var returnedgoods_motivations_other="Другое";

var i18nOrderStatus = new Array();
i18nOrderStatus[0]='В ожидании на подтверждение';
i18nOrderStatus[1]='В оплате';
i18nOrderStatus[2]='Подтвержденный';
i18nOrderStatus[3]='Отправлен';
i18nOrderStatus[4]='Даставлен';
i18nOrderStatus[5]='Зарезервированный';
i18nOrderStatus[6]='Дропшиппинг';
i18nOrderStatus[2000]='Отменен';
i18nOrderStatus[2001]='Ошибка';
i18nOrderStatus[3001]='В обработке';
i18nOrderStatus[3002]='Готов';

i18nOrderStatus[1000]='Платеж аннулирован';
i18nOrderStatus[2002]='Проверка статуса платежа не произошла с успехом';
i18nOrderStatus[2003]='Возмещённый';
i18nOrderStatus[2005]='Отвергнутый';
i18nOrderStatus[3003]='Недоступен';
i18nOrderStatus[5001]='Неразрешенный';
i18nOrderStatus[5002]='Разрешенный';
i18nOrderStatus[5003]='Дропшиппинг - Кумулятивный';

